module.exports = __webpack_public_path__ + "027903443bbad7dfff06c19e18b37287.png";